import { ComponentType } from 'react';
import { JSONObject } from '../types/types';
import { useVisibilityResolve } from '../hooks/useVisibilityResolve';

export type WithVisiblityResolveProp = {
  visible?: boolean | string;
  resolveData: JSONObject;
};

export const withVisiblityResolve = <P extends WithVisiblityResolveProp>(
  Component: ComponentType<Omit<P, 'visible'> & { visible: boolean }>
) => {
  const WithVisiblityResolve = (props: P) => {
    const { visible, resolveData, ...rest } = props;
    // Identity for the `visibility` debug feature — wrapped components carry
    // name (form items), item.name (layout panel) or caption (groups).
    const { name, item, caption } = props as {
      name?: string;
      item?: { name?: string };
      caption?: string;
    };
    const { visible: resolvedVisible } = useVisibilityResolve(
      visible,
      resolveData,
      name ?? item?.name ?? caption
    );

    return (
      <Component
        {...(rest as Omit<P, 'visible'>)}
        visible={resolvedVisible}
        resolveData={resolveData}
      />
    );
  };

  WithVisiblityResolve.displayName = `withVisiblityResolve(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WithVisiblityResolve;
};
